
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Documento from "model/documentos/Documento";
import DocumentoAlterarValidade from "model/documentos/DocumentoAlterarValidade";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { useLoadingContext } from "provider/LoadingProvider";
import { useState } from "react";
import DocumentoService from "service/documentos/DocumentoService";

type Props = {
    visible: boolean;
    onHide: () => void;
    documento: Documento
    onConfirm: () => void;
}

const documentoService = new DocumentoService();
export default function ModalDocumentoAlterarValidade(props: Props) {
    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();

    const [mesesPrazoValidade, setMesesPrazoValidade] = useState<number>(props.documento.mesesPrazo || 0);
    const [controlaPrazoValidade, setControlaPrazoValidade] = useState<boolean>(props.documento.controlaPrazo || false);
    const [aplicarNaVersaoAtual, setAplicarNaVersaoAtual] = useState<boolean>(false);

    function handleConfirm() {
        if (controlaPrazoValidade && mesesPrazoValidade <= 0) {
            msgAlerta("Erro", "O prazo de validade deve ser maior que zero.");
            return;
        }

        const dados : DocumentoAlterarValidade = {
            id: props.documento.id,
            controlaPrazo: controlaPrazoValidade,
            mesesPrazo: mesesPrazoValidade,
            aplicarNaVersaoAtual: aplicarNaVersaoAtual
        }

        startLoading();
        documentoService.alterarValidade(dados).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro", error?.data?.message || "Erro ao alterar validade");
            console.error("Erro alterar validade do documento:", error);
        });

    }

    return (
        <Dialog
            header="Alterar validade"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Alterar" icon="pi pi-check" onClick={handleConfirm} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                <Label>Documento</Label>
                <div>
                    <span>{props.documento.codigoInterno} - {props.documento.nome}</span>
                </div>

            </div>

            <div style={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
                <Checkbox checked={controlaPrazoValidade} onChange={(e) => setControlaPrazoValidade(e.checked as boolean)} />
                <label>Controla prazo de validade</label>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Label style={{ fontWeight: 700, color: controlaPrazoValidade ? "#000" : "#777" }} obrigatorio={controlaPrazoValidade}>Prazo de validade (meses)</Label>
                <div className="col-sm-12">
                    <InputNumber
                        disabled={!controlaPrazoValidade}
                        value={mesesPrazoValidade}
                        onChange={(e) => {
                            setMesesPrazoValidade(e.value as number)
                        }}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', columnGap: 8, marginTop: 16 }}>
                <Checkbox checked={aplicarNaVersaoAtual} onChange={(e) => setAplicarNaVersaoAtual(e.checked as boolean)} />
                <label>Aplicar alteração na versão vigente</label>
            </div>

        </Dialog>
    );
}
